import { useParams } from "react-router-dom";

export default function DocumentView() {
    const { fileName } = useParams();

    return (
          <iframe src={require(`../public_documents/${fileName}`)} width="100%" height="100%">
          </iframe>
    );
}